module.exports = __webpack_public_path__ + "static/media/facebook-icon.4d02dee4.svg";